import { PROJECTS_DEFAULT_QUERY_PARAMS } from "@/components";
import DashboardTablePreview from "@/components/Dashboard/DashboardTablePreview";
import { SmallerNameCol } from "@/components/ProjectsTable/styled";
import { recentlyApprovedIntakeFieldNames as fieldNames } from "@/enums";
import { routes } from "@/helpers";
import { useColumnFactory } from "@/hooks";
import { useGetRecentlyApprovedIntakesQuery } from "@/services/dashboard";
import { faLock } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import { useIntl } from "react-intl";
import { DateParam, useQueryParams } from "use-query-params";

const RecentlyApprovedIntakePreview = () => {
  const intl = useIntl();
  const [queryParams, setQueryParams] = useQueryParams({
    ...PROJECTS_DEFAULT_QUERY_PARAMS,
    estimatedLaunchDate: DateParam,
  });

  const { createIntakeViewLinkColumn } = useColumnFactory(
    queryParams,
    setQueryParams
  );

  const {
    data: { data: projectRecentlyApprovedIntakes, totalCount } = {},
    isFetching,
  } = useGetRecentlyApprovedIntakesQuery({ ...queryParams, pageSize: 5 });

  return (
    <DashboardTablePreview
      data={projectRecentlyApprovedIntakes}
      isFetching={isFetching}
      title={intl.formatMessage({
        id: "dashboard.titles.recentlyApprovedIntake",
      })}
      titleRoute={routes.dashboardFullViews.recentlyApprovedIntake}
      totalCount={totalCount}
      columns={[
        createIntakeViewLinkColumn(
          intl.formatMessage({ id: "dashboard.columns.intake" }),
          intl.formatMessage({ id: "dashboard.columns.view" })
        ),
        {
          title: intl.formatMessage({ id: "dashboard.columns.projectNumber" }),
          dataIndex: fieldNames.projectNumber,
          width: 80,
        },
        {
          title: intl.formatMessage({ id: "dashboard.columns.projectName" }),
          render: ({ projectName, secureProject }) => (
            <SmallerNameCol>
              {secureProject && (
                <Tooltip
                  title={intl.formatMessage({ id: "project.isSecureMessage" })}
                  trigger={["hover"]}
                >
                  <FontAwesomeIcon icon={faLock} className="mr-2" />
                </Tooltip>
              )}
              {projectName}
            </SmallerNameCol>
          ),
        },
        {
          title: intl.formatMessage({ id: "dashboard.columns.type" }),
          dataIndex: fieldNames.projectTypeLabel,
        },
        {
          title: intl.formatMessage({
            id: "dashboard.columns.financeApprovalGroup",
          }),
          dataIndex: fieldNames.financeApprovalGroupLabel,
        },
        {
          title: intl.formatMessage({ id: "dashboard.columns.approverRole" }),
          dataIndex: fieldNames.approverName,
        },
        {
          title: intl.formatMessage({ id: "dashboard.columns.approverName" }),
          dataIndex: fieldNames.approverUserName,
        },
        {
          title: intl.formatMessage({ id: "dashboard.columns.days" }),
          dataIndex: fieldNames.daysAvailable,
        },
      ]}
    />
  );
};

export default RecentlyApprovedIntakePreview;
